export default __webpack_public_path__ + "static/media/1545.47d34627.png";